export const NAME = 'activationSteps';

export enum ACTIVATION_STEPS {
  HIT_ALLOW = 'hit_allow',
  INSTALL = 'install',
  READY_TO_PLAY = 'ready_to_play',
}
